<mat-form-field>
  <mat-label>{{'Options.Formality' | translate }}</mat-label>
  <mat-select [(ngModel)]="translationOptions.selectedFormality" name="formality">
    <mat-select-trigger>
      {{ 'Options.FormalitySelection.' + translationOptions.selectedFormality | translate }}
    </mat-select-trigger>
    @for (formality of translationOptions.formalityOptions; track formality) {
      <mat-option [value]="formality">
        {{ 'Options.FormalitySelection.' + formality | translate }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>